import { render, staticRenderFns } from "./MoMain.vue?vue&type=template&id=5e0b5fd3&scoped=true"
import script from "./MoMain.vue?vue&type=script&lang=js"
export * from "./MoMain.vue?vue&type=script&lang=js"
import style0 from "./MoMain.vue?vue&type=style&index=0&id=5e0b5fd3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b5fd3",
  null
  
)

export default component.exports